/**
 * Client entry — used for both dev and after SSG.
 *
 * When a page was pre-rendered, `window.__BLOX_STATE__` contains the
 * already-resolved data embedded at build time. The fetch interceptor from
 * @bagelink/blox returns that data instantly, and `provideBloxData()` hydrates
 * `useData()` from `window.__BLOX_DATA__` — so the first render makes zero
 * network requests and matches the SSR tree.
 */
import { createBloxApp } from '@bagelink/blox'
import { createApi } from '@shared/api'

import '@bagelink/vue/styles/core.css'
import '@bagelink/blox/style.css'
import '@/styles/theme.css'
import '@/styles/main.css'

import App from './App.vue'
import { bloxSite } from './blox.config'
import router from './router'
import { installEmbedPreviewGuard, isBloxDesignerPreview } from './utils/embedPreview'

// Inside the Blox designer, embeds that refuse framing would paint the browser's
// "refused to connect" error. Swap them for a quiet placeholder instead (covers
// iframes inside rich-text fields, popups and articles too).
if (isBloxDesignerPreview()) installEmbedPreviewGuard()

createBloxApp({
	...bloxSite,
	rootComponent: App,
	router,
	navigation: 'document',
	createApi: ({ baseURL }) => { createApi({ baseURL }) },
})
